import type {Palette} from '../types';
import {PALETTE_ID} from '../types';

export default {
    id: PALETTE_ID.DEFAULT_20,
    scheme: [
        '#3D97F2',
        '#FF6A59',
        '#7FD169',
        '#FFB433',
        '#AB94D9',
        '#8CD5FF',
        '#FF8CB2',
        '#60A196',
        '#4C73BF',
        '#B8C9CC',
        '#52CCC2',
        '#C3E55C',
        '#807D73',
        '#FF8C00',
        '#FFDC73',
        '#CC9966',
        '#CC5252',
        '#FFB28C',
        '#9661FF',
        '#D4BFFF',
    ],
    datalens: true,
} as Palette;
